<template>
  <!-- 视频详情 -->
  <div class="videoDetail">
    <headerNav activeIndex="video" @setBanner="setBanner"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="pc" style="width: 1151px; margin: 100px auto 86px">
      <div
        style="
          border-bottom: 1px solid #719468;
          padding: 14px 0;
          line-height: 23px;
          display: flex;
        "
      >
        <div style="font-size: 23px" class="clickBtn1" @click="goHome">
          首页
        </div>
        <div style="font-size: 18px; margin: 0 12px">-</div>
        <div style="font-size: 18px" class="clickBtn1" @click="goBack">
          视频中心
        </div>
      </div>
      <div style="margin: 36px 0 56px; text-align: center">
        <div style="color: #719468; font-size: 36px; line-height: 36px">
          {{ detail.title }}
        </div>
        <div
          style="
            font-size: 14px;
            color: #535353;
            line-height: 23px;
            margin-top: 20px;
          "
        >
          <span style="margin-right: 16px">日期：{{ detail.releaseTime }}</span>
          <span style="margin-right: 16px">作者：{{ detail.authorName }}</span>
          <i class="el-icon-view" style="margin-right: 4px"></i>
          <span>阅读量：{{ detail.readingOnFictitiou }}</span>
        </div>
      </div>
      <video controls width="1151" :poster="getUrlPrefix(detail.coverImage)">
        <source
          :src="getUrlPrefix(detail.images)"
          type="video/mp4"
          v-if="videoShow"
        />
      </video>
    </div>
    <div class="mobile" style="padding: 0.6rem 0.26rem 0.2rem;">
      <div
        style="color: #719468; font-size: 22px;line-height:1.5;"
      >
        {{ detail.title }}
      </div>
      <div
        style="
          font-size: 14px;
          color: #0000004d;
          margin-top: 0.2rem;
          padding-bottom:0.15rem;
          border-bottom:1px solid #e5e5e5;
        "
      >
        <i class="el-icon-user" style="margin-right: 1px"></i>
        <span style="margin-right: 12px"
          >{{ detail.authorName }}</span
        >
        <i class="el-icon-date" style="margin-right: 1px"></i>
        <span style="margin-right: 12px"
          >{{ detail.releaseTime }}</span
        >
        
        <i class="el-icon-view" style="margin-right: 1px"></i>
        <span>{{ detail.readingOnFictitiou }}</span>
      </div>
     <video controls :poster="getUrlPrefix(detail.coverImage)" style="width:100%;">
        <source
          :src="getUrlPrefix(detail.images)"
          type="video/mp4"
          v-if="videoShow"
        />
      </video>
    </div>
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from '@/components/headerNav/index'
import bannerNav from '@/components/banner/index'
import footerNav from '@/components/footerNav/index'
import { findVideoById } from '@/api/videoList'
import { getConfByKey, updateReadingVolume } from '@/api/common'

export default {
  name: 'videoListDetail',
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: null,
        Mcarousel: '',
      }, //轮播图
      show: false,
      mobile: false,
      currentPage1: 1,
      videoShow: false,
      detail: {},
    }
  },
  mounted() {
    findVideoById({ id: this.$route.params.id }).then((res) => {
      if(res.data !== null){
        this.detail = res.data
        this.postMessage(
            this.detail.title,
            this.detail.authorName,
            window.location.href,
            this.getUrlPrefix(this.detail.coverImage)
          );
        this.videoShow = true
        updateReadingVolume({ id: this.$route.params.id }).then((res) => {})
      }else{
        this.$router.replace({name:'404'})
      }
    }).catch(()=>{
      this.$router.replace({name:'500'})
    })
  },
  methods: {
    setBanner(url,mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      }
    },
    goHome() {
      this.$router.push({ name: 'home' })
    },
    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss">
.videoDetail {
  .max-width {
  }
}
</style>


// WEBPACK FOOTER //
// src/views/videoList/detail.vue